import { useTranslation } from "react-i18next";
import logo from "../../../assets/logo.png";

export default function Porcoes() {
  const { t } = useTranslation();

  return (
    <section id="porcoes">
      <div className="imagem-texto">
        <img src={logo} alt="Logo GranCaju" />
        <h1>{t("home.porcoes.titulo")}</h1>
      </div>
      <p>
        {t("home.porcoes.descricao.p1.texto")}
        <br />
        {t("home.porcoes.descricao.p1.t1")}
        <br />
        {t("home.porcoes.descricao.p1.t2")}
        <br />
        {t("home.porcoes.descricao.p2")}
      </p>

      <div className="porcoes-opcoes">
        <div className="porcao-card">
          <h1>{t("home.porcoes.40g.titulo")}</h1>
          <p>{t("home.porcoes.40g.subtitulo")}</p>
          <ul className="lista-castanha">
            <li>{t("home.porcoes.40g.topicos.t1")}</li>
            <li>{t("home.porcoes.40g.topicos.t2")}</li>
            <li>{t("home.porcoes.40g.topicos.t3")}</li>
            <li>{t("home.porcoes.40g.topicos.t4")}</li>
          </ul>
        </div>

        <div className="porcao-card">
          <h1>{t("home.porcoes.500g.titulo")}</h1>
          <p>{t("home.porcoes.500g.subtitulo")}</p>
          <ul className="lista-castanha">
            <li>{t("home.porcoes.500g.topicos.t1")}</li>
            <li>{t("home.porcoes.500g.topicos.t2")}</li>
            <li>{t("home.porcoes.500g.topicos.t3")}</li>
          </ul>
        </div>
      </div>

      {/* <div className="porcoes-cta">
        <p>{t("home.porcoes.botao.pergunta")}</p>
        <button>{t("home.porcoes.botao.botao")}</button>
      </div> */}
    </section>
  );
}
